import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import GatewayStatsSection from "@/components/GatewayStatsSection";
import AboutSection from "@/components/AboutSection";
import SEOHead from "@/components/SEOHead";

// Lazy load below-the-fold sections to improve TTI
const OurRegionSection = lazy(() => import("@/components/OurRegionSection"));
const StrategicPartnersSection = lazy(() => import("@/components/StrategicPartnersSection"));
const NewSection = lazy(() => import("@/components/NewSection"));
const VideoSection = lazy(() => import("@/components/VideoSection"));
const LogoCarouselSection = lazy(() => import("@/components/LogoCarouselSection"));
const CountriesSection = lazy(() => import("@/components/CountriesSection"));
const NewsEventsSection = lazy(() => import("@/components/NewsEventsSection"));
const Footer = lazy(() => import("@/components/Footer"));
const Index = () => {
  return (
    <main className="min-h-screen overflow-x-hidden">
      <SEOHead />
      <Navbar />
      <HeroSection />
      <GatewayStatsSection />
      <AboutSection />
      <Suspense fallback={null}>
        <OurRegionSection />
        <StrategicPartnersSection />
        <NewSection />
        <VideoSection />
        <LogoCarouselSection className="mt-0 pt-[128px]" />
        <CountriesSection />
        <NewsEventsSection />
        <Footer />
      </Suspense>
    </main>
  );
};
export default Index;
